package example.shadcn_kotlin.ui.pages.docs.components.date_picker

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.DatePickerDemo

@Page
@Composable
fun IndexPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/date-picker/index.md", mapOf("title" to listOf("Date Picker"), "description" to listOf("A date picker component with range and presets.")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import example.shadcn_kotlin.ui.pages.components.demo.utils.format
import lucide_react.CalendarIcon
import react.FC
import react.Props
import react.dom.html.ReactHTML.span
import react.useState
import shadcn.ui.components.*
import web.cssom.ClassName
import kotlin.js.Date

val DatePickerDemo = FC<Props> {
    val (date, setDate) = useState<Date>()

    Popover {
        PopoverTrigger {
            asChild = true
            Button {
                variant = "outline"
                className =
                    ClassName(
                    "w-[280px] justify-start text-left font-normal" + if (date == null) " text-muted-foreground" else "")
                CalendarIcon {
                    className = ClassName("mr-2 h-4 w-4")
                }
                if (date != null)
                    +format(date,"PPP")
                else {
                    span {
                        +"Pick a date"
                    }
                }
            }
        }
        PopoverContent {
            className = ClassName("w-auto p-0" )
            Calendar {
                mode = "single"
                selected=date
                onSelect= setDate
                initialFocus = true
            }
        }
    }
}"""){ 
 DatePickerDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("installation")
 }) {
                org.jetbrains.compose.web.dom.Text("Installation")
            }
            org.jetbrains.compose.web.dom.P({ classes("leading-7","[&:not(:first-child)]:mt-6") }) {
                org.jetbrains.compose.web.dom.Text("The Date Picker is built using a composition of the ")
                org.jetbrains.compose.web.dom.Code({ classes("bg-muted","py-[0.2rem]","px-[0.3rem]","rounded","text-sm") }) {
                    org.jetbrains.compose.web.dom.Text("<Popover />")
                }
                org.jetbrains.compose.web.dom.Text(" and the ")
                org.jetbrains.compose.web.dom.Code({ classes("bg-muted","py-[0.2rem]","px-[0.3rem]","rounded","text-sm") }) {
                    org.jetbrains.compose.web.dom.Text("<Calendar />")
                }
                org.jetbrains.compose.web.dom.Text(" components.")
            }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""val (date, setDate) = useState<Date>()
    Popover {
        PopoverTrigger {
            asChild = true
            Button {
                variant = "outline"
                className =
                    ClassName(
                    "w-[280px] justify-start text-left font-normal${'$'}{
                        if (date == null) " text-muted-foreground" else ""
                    }")
                CalendarIcon {
                    className = ClassName("mr-2 h-4 w-4")
                }
                if (date != null)
                    +format(date,"PPP")
                else {
                    span {
                        +"Pick a date"
                    }
                }
            }
        }
        PopoverContent {
            className = ClassName("w-auto p-0" )
            Calendar {
                mode = "single"
                selected=date
                onSelect= setDate
                initialFocus = true
            }
        }
    }
""", lang= "kotlin", highlight= "")
            org.jetbrains.compose.web.dom.P({ classes("leading-7","[&:not(:first-child)]:mt-6") }) {
                org.jetbrains.compose.web.dom.Text("See the ")
                org.jetbrains.compose.web.dom.A("https://react-day-picker.js.org", { classes("font-medium","underline","underline-offset-4") }) {
                    org.jetbrains.compose.web.dom.Text("React DayPicker")
                }
                org.jetbrains.compose.web.dom.Text(" documentation for more information.")
            }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("examples")
 }) {
                org.jetbrains.compose.web.dom.Text("Examples")
            }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("date-picker")
 }) {
                org.jetbrains.compose.web.dom.Text("Date Picker")
            }
            ComponentPreview("""import example.shadcn_kotlin.ui.pages.components.demo.utils.format
import lucide_react.CalendarIcon
import react.FC
import react.Props
import react.dom.html.ReactHTML.span
import react.useState
import shadcn.ui.components.*
import web.cssom.ClassName
import kotlin.js.Date

val DatePickerDemo = FC<Props> {
    val (date, setDate) = useState<Date>()

    Popover {
        PopoverTrigger {
            asChild = true
            Button {
                variant = "outline"
                className =
                    ClassName(
                    "w-[280px] justify-start text-left font-normal" + if (date == null) " text-muted-foreground" else "")
                CalendarIcon {
                    className = ClassName("mr-2 h-4 w-4")
                }
                if (date != null)
                    +format(date,"PPP")
                else {
                    span {
                        +"Pick a date"
                    }
                }
            }
        }
        PopoverContent {
            className = ClassName("w-auto p-0" )
            Calendar {
                mode = "single"
                selected=date
                onSelect= setDate
                initialFocus = true
            }
        }
    }
}"""){ 
 DatePickerDemo {} 
 }
        }
    }
}
